import { render, staticRenderFns } from "./purchaseRemits.vue?vue&type=template&id=2a607a90&"
import script from "./purchaseRemits.vue?vue&type=script&lang=js&"
export * from "./purchaseRemits.vue?vue&type=script&lang=js&"
import style0 from "./purchaseRemits.vue?vue&type=style&index=0&id=2a607a90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports